module.exports = __webpack_public_path__ + "static/about-1-2-39a63317c1ac52e007154e0d91129832.jpg";